/**
 * Feature flags for the D365FO Data Explorer UI.
 */

/**
 * Controls visibility of the D365 commit/confirm/update actions across the explorer:
 * the Sales Order and Service Order toolbar buttons (Confirm / Update / Confirm for
 * Invoice) and the clickable Commit/Rollback steps in the manufacturing status panel.
 *
 * Currently OFF — the team is sticking with the CS monolith's commit functionality
 * for now, and the explorer commit paths may be out of date (AB#12733). The underlying
 * code/handlers are intentionally left intact; flip this to `true` to restore the actions.
 */
export const SHOW_D365_COMMIT_ACTIONS = false;
